import classNames from 'classnames';
import React from 'react';
import './UnstyledButton.less';

function UnstyledButton({
  // eslint-disable-next-line react/prop-types -- auto-generated TECH-258
  className,
  ...props
}: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
  return <button className={classNames('button-unstyled', className)} {...props} />;
}

export default UnstyledButton;
